import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../apiUrl";

export const getGruposLaboratorios = createAsyncThunk(
  'gruposLaboratorios/listar',
  async (_, { rejectedWithValue }) => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/grupos-laboratorios`
      )
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectedWithValue(error.response.data)
      }
      return rejectedWithValue(error.message);
    }
  }
)

export const agruparLaboratorios = createAsyncThunk(
  'agruparLaboratorios/listar',
  async (_, { rejectedWithValue }) => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/agrupacion-laboratorios`
      )
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectedWithValue(error.response.data)
      }
      return rejectedWithValue(error.message);
    }
  }
)

export const createGrupoLaboratorio = createAsyncThunk(
  "gruposLaboratorios/crear",
  async (nuevoGrupo, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/api/v1/grupos-laboratorios/registrar`,
        nuevoGrupo
      );
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteGrupoLaboratorio = createAsyncThunk(
  "grupoLaboratorios/eliminar",
  async (grupoId, { rejectWithValue }) => {
    try {
      await axios.delete(`${apiUrl}/api/v1/grupos-laboratorios/eliminar/${grupoId}`);
      return grupoId;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
)


export const createAgrupacionLaboratorios = createAsyncThunk(
  "agruparLaboratorios/crear",
  async (nuevAgrupacion, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/api/v1/agrupacion-laboratorios/registrar`,
        nuevAgrupacion
      );
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAgrupacionLaboratorios = createAsyncThunk(
  "agrupaarLaboratorios/eliminar",
  async (grupoLaboratorioId, { rejectWithValue }) => {
    try {
      await axios.delete(`${apiUrl}/api/v1/agrupacion-laboratorios/eliminar/${grupoLaboratorioId}`)
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
)

const gruposLaboratoriosSlice = createSlice({
  name: "gruposLaboratorios",
  initialState: {
    data: [],
    agrupaciones: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGruposLaboratorios.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getGruposLaboratorios.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getGruposLaboratorios.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: 'Fallo al cargar resgistros de grupos de laboratorios'
        };
        state.data = [];
      })

      // Crear grupo
      .addCase(createGrupoLaboratorio.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createGrupoLaboratorio.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data.unshift(action.payload); // Agrega el nuevo grupo al principio
      })
      .addCase(createGrupoLaboratorio.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || {
            message: "Fallo al crear el grupo de laboratorio",
          };
      })

      //Eliminar Grupo
      .addCase(deleteGrupoLaboratorio.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteGrupoLaboratorio.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = state.data.filter(gru => gru.id !== action.payload);
      })
      .addCase(deleteGrupoLaboratorio.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: "Error al eliminar el grupo de laboratorio"
        }
      })

      // Obtener agrupaciones de laboratorio
      .addCase(agruparLaboratorios.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(agruparLaboratorios.fulfilled, (state, action) => {
        state.isLoading = false;
        state.agrupaciones = action.payload;
      })
      .addCase(agruparLaboratorios.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || {
            message: 'Fallo al cargar las agrupaciones de laboratorio',
          };
        state.agrupaciones = [];
      })

      // Crear agrupación de laboratorio
      .addCase(createAgrupacionLaboratorios.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createAgrupacionLaboratorios.fulfilled, (state, action) => {
        state.isLoading = false;
        // Puedes agregar una lógica similar a los grupos si quieres almacenar la nueva agrupación
        state.agrupaciones = [
          ...(state.agrupaciones || []),
          action.payload,
        ];
      })
      .addCase(createAgrupacionLaboratorios.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || {
            message: 'Fallo al crear la agrupación de laboratorio',
          };
      })

      //Eliminar agrupacion de laboratorios
      .addCase(deleteAgrupacionLaboratorios.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(deleteAgrupacionLaboratorios.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = state.data.filter(agru => agru.id !== action.payload);
      })
      .addCase(deleteAgrupacionLaboratorios.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: "Error al Eliminar la Agrupacion de laboratorios"
        }
      })

  }
})


export const { resetGruposLaboratorios } = gruposLaboratoriosSlice.actions;
export default gruposLaboratoriosSlice.reducer;